import { render, staticRenderFns } from "./CardOrderForm.vue?vue&type=template&id=016b7af1&scoped=true"
import script from "./CardOrderForm.vue?vue&type=script&lang=js"
export * from "./CardOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016b7af1",
  null
  
)

export default component.exports